import { AxiosInstance } from 'axios';
import { useApi } from '../services/hooks/apiRedux';
import { useAuth } from '../store/auth';
import i18n from '../plugins/i18n/i18n';
import { errorToast, successToast } from '../utils/toasts';
import { InstancesServices } from '../services/InstancesServices';
import { UpdateColorPayload } from '../services/Interfaces/IAccountService';


export const useColors = () => {
  const api: AxiosInstance = useApi();
  const { token } = useAuth();

  const updateUseColors = async (payload: UpdateColorPayload[]) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Language': i18n.language.toLowerCase()
        }
      };

      await InstancesServices.updateColors(api, payload, config);
      successToast(i18n.t('environment.stylesUpdatedSuccess'));
    } catch (error: any) {
      console.error('Erro ao atualizar taxa:', error);
      errorToast(error?.response?.data?.error?.[0] || i18n.t('environment.errorUpdatingFee'));
    }
  };

  const updateUseLogo = async (file: any) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Language': i18n.language.toLowerCase()
        }
      };

      await InstancesServices.uploadLogo(api, file, config);
      successToast(i18n.t('environment.logoUploadedSuccess'));
    } catch (error: any) {
      console.error('Erro ao atualizar taxa:', error);
      errorToast(error?.response?.data?.message || i18n.t('environment.errorUpdatingFee'));
    }
  };

  return {
    updateUseColors,
    updateUseLogo
  };
};
